import React from 'react';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { Box } from '@material-ui/core';
import Account from '../Account';
import { WorkspaceProps, STATIC_WORKSPACE } from 'src/constants/layouts';
import { ReactComponent as IAMLogo } from 'src/images/iam_logo.svg';

const useStyles = makeStyles(() => ({
  wrapper: {
    marginLeft: 67,
    padding: '0 1rem 0 2rem',
    width: 'calc(100% - 67px)',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#fff',
    zIndex: 999
  },
  openWrapper: {
    marginLeft: 185,
    padding: '0 1rem 0 2rem',
    width: 'calc(100% - 185px)',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#fff',
    zIndex: 99
  },
  topBar: {
    // marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  title: {
    fontFamily: 'Archivo',
    color: '#000',
    fontSize: 26,
    fontWeight: 500
  },
  subTitle: {
    fontFamily: 'Archivo',
    color: '#9a9a9a',
    fontSize: 16,
    fontWeight: 400
  },

  hr: {
    height: 1,
    border: 0,
    backgroundColor: '#D9D9D9'
  },

  logo: {
    width: 64,
    height: 24
    // margin: '32px 80px 128px 48px'
  }
}));

const UiHeader: FC<{ visible: boolean }> = ({ visible }) => {
  const classes = useStyles();
  const location = useLocation();
  const STATIC_CURRENT = STATIC_WORKSPACE.filter(
    (routes: WorkspaceProps) => routes.id === location.pathname
  );

  return (
    <Box className={visible ? classes.openWrapper : classes.wrapper}>
      <Box className={classes.topBar}>
        <Box>
          <IAMLogo className={classes.logo} />
          {/* <p className={classes.title}>{STATIC_CURRENT[0].title}</p> */}
        </Box>
        <Account />
      </Box>
    </Box>
  );
};

export default UiHeader;
